module.exports = __webpack_public_path__ + "static/img/10.6fc7683.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/2/sp/10.png
// module id = 5d7t
// module chunks = 0